export const mergeArray = (array1, array2, propName) => {
    const response = [...array1];
    for (const obj2 of array2) {
        const objetoExistente = response.find(
            (obj1) => obj1[propName] === obj2[propName]
        );
        if (!objetoExistente) response.push(obj2);
        else response[response.indexOf(objetoExistente)] = obj2;
    }
    return response;
};
